module.exports = __webpack_public_path__ + "static/media/8OLA19.e27cfa04.jpg";